<template>
<!--  <div>-->

<!--    <section v-if="$route.name == 'custom-payment-60-amba'" class="orep-header mont">-->
<!--      <section class="orep-badge text-uppercase">-->
<!--        Insurance for Savvy Professionals-->
<!--      </section>-->
<!--      <section class="logo-wrapper">-->
<!--        <img src="../../../public/assets/images/mercer-logo.png" class="logo" alt="Logo">-->
<!--        <span class="logo-text text-uppercase"></span>-->
<!--      </section>-->
<!--    </section>-->

<!--    <section v-else-if="$route.name == 'custom-payment-60-realshield'" class="orep-header mont">-->
<!--      <section class="orep-badge text-uppercase">-->
<!--        Insurance for Savvy Professionals-->
<!--      </section>-->
<!--      <section class="logo-wrapper">-->
<!--        <img src="../../../public/assets/images/realshield-logo-blue.png" class="logo" alt="Logo">-->
<!--        <span class="logo-text text-uppercase"></span>-->
<!--      </section>-->
<!--    </section>-->

<!--    <section v-else-if="$route.name == 'custom-payment-ibdpro'" class="orep-header mont">-->
<!--      <section class="orep-badge text-uppercase">-->
<!--        Insurance for Savvy Professionals-->
<!--      </section>-->
<!--      <section class="logo-wrapper">-->
<!--        <img src="../../../public/assets/images/ibdpro-logo.svg" class="logo-ibdpro" alt="Logo">-->
<!--        <span class="logo-text text-uppercase"></span>-->
<!--      </section>-->
<!--    </section>-->


<!--    <section v-else class="orep-header mont">-->
<!--      <section class="orep-badge text-uppercase">-->
<!--        Insurance for Savvy Professionals-->
<!--      </section>-->
<!--      <section class="logo-wrapper">-->
<!--        <img src="../../../public/assets/images/logo@2.png" class="logo" alt="Logo">-->
<!--        <span class="logo-text text-uppercase"></span>-->
<!--      </section>-->
<!--    </section>-->



<!--    <router-view></router-view>-->
<!--  </div>-->

  <router-view></router-view>
</template>

<script>
  export default {
    name: "ipfs",
    data() {
      return {
        isActive: false
      };
    },
    methods: {
      hamSpin() {
        this.isActive = !this.isActive;
      }
    }
  }
</script>
